
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import { Table } from "@common/src/utils/decorator";
import ExpandControl from "@/components/scope/expand-control.vue";
import dayjs from "dayjs";
import { addCurrencyUnit } from "@common/src/utils/tools";
import t from "@common/src/i18n/t";
const finance = namespace("finance");
const base = namespace("base");
const setting = namespace("setting");
const app = namespace("app");
@Component({
  components: { ExpandControl }
})
@Table("loadListData")
export default class TmallBillView extends Vue {
  @finance.Action confirmBill;
  @finance.Action confirmBillReceived;
  @finance.Action getBillDetail;
  @base.Action getDictionaryList;
  @setting.Action getPatternPaymentList;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  emptyToLine = emptyToLine;
  dayjs = dayjs;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  get breadData() {
    return [{ name: t("finance.tmall-bills"), path: "/finance/tmall-bill" }, { name: t("finance.billing-details") }];
  }
  get billId() {
    return this.$route.params.id;
  }
  created() {
    this.init();
    this.loadListData();
  }
  customerList: any[] = [];
  showCollectionWay: boolean = false;
  showBillConfirm: boolean = false;
  collectionWayValue: string = "";
  showCollectionConfirm: boolean = false;
  detailData: any = {};
  payWayList: any[] = [];
  isExpandServiceCost: boolean = true; // 是否展开工时费配件费
  init() {
    this.getPatternPaymentList({
      status: "1"
    }).then(data => {
      this.payWayList = this.$safeValue(data, "data", []);
    });
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.getBillDetail({
      billNo: this.billId,
      orderItems: this.mix_sortParams,
      pageSize: this.mix_pageSize,
      pageNum: this.mix_pageNum
    }).then(data => {
      this.detailData = data.data;
      return data.data.orderCount;
    });
  }
  handleShowCollectionWay() {
    // 显示 选择收款方式
    this.showCollectionConfirm = false;
    this.showCollectionWay = true;
  }
  handleShowCollectionConfirm() {
    // 显示 收款确认提示
    this.showCollectionConfirm = true;
  }
  handleShowBillConfirm() {
    // 显示 账单确认
    this.showBillConfirm = true;
  }
  handleBillConfirm() {
    // 处理账单确认
    this.confirmBill({
      billNo: this.billId
    }).then(() => {
      this.showBillConfirm = false;
      this.detailData.billStatus = 2; // 修改账单状态
      this.detailData.billStatusDesc = t("finance.confirmed");
      this.$message.success(`${t("finance.bill")}“${this.billId}”${t("finance.confirmed")}`);
    });
  }
  handleCollectionConfirm() {
    if (!this.collectionWayValue) {
      return this.$message.error(t("finance.select-mode-payment"));
    }
    this.btnStartLoading();
    this.confirmBillReceived({
      billNo: this.billId,
      paidMethod: this.collectionWayValue
    })
      .then(() => {
        this.showCollectionWay = false;
        this.detailData.billStatus = 3; // 修改账单状态
        this.detailData.billStatusDesc = t("finance.payment-received");
        this.$message.success(`${t("finance.tmall-bills")}“${this.billId}”${t("finance.all-orders-received")}`);
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
}
